<ng-container *ngIf="{ props: properties, currentStatus: status } as resolver">

  <ng-container *ngIf="resolver.props; else skeletonView">

    <lib-block-title
      id="title"
      [title]="title">
    </lib-block-title>

    <section
      id="product-image"
      class="fx-col fx-gap-2 py-2 fx-align-center fx-justify-start radius-4 block-bg-contrast">

      <div
        *ngIf="resolver.currentStatus as statusModel"
        class="fx-row radius-4 border-1 fx-align-center fx-gap-3 fx-justify-between p-3 w-full"
        [ngClass]="statusModel.cssClasses">

        <div class="fx-row fx-align-center fx-gap-2">
          <mat-icon [ngClass]="statusModel.iconCssClasses">
            {{ statusModel.icon ?? 'info' }}
          </mat-icon>
          <div class="tw-text-sm tw-font-medium text-grey-300">
            {{ statusModel.name | titlecase }}
          </div>
        </div>

        <div class="tw-text-base tw-font-normal ml-auto">
          {{ statusModel.value | titlecase }}
        </div>
      </div>

      <div class="fx-col fx-center fx-g-1">
        <img
          *ngIf="resolvedImageSrc as imageSrc"
          class="h-20"
          [src]="imageSrc">
        <span class="tw-font-medium tw-text-sm text-grey-400">
          {{ (deviceTypeLabel || '') | titlecase }}
        </span>
        <span class="ellipsed tw-font-normal tw-text-base text-grey-400">
          {{ deviceId }}
        </span>
      </div>
    </section>

    <section
      *ngIf="hasProperties"
      id="product-details">
      <div
        *ngFor="let property of properties"
        class="fx-row radius-4 block-bg-contrast fx-align-center fx-gap-3 fx-justify-between p-3">

        <mat-icon [ngClass]="property.iconCssClasses">
          {{ property.icon ?? 'info' }}
        </mat-icon>

        <div class="tw-text-sm tw-font-medium text-grey-300">
          {{ property.name | titlecase }}
        </div>

        <div
          class="tw-text-base tw-font-normal text-grey-400 ml-auto"
          [ngClass]="property.cssClasses">
          {{ property.value | titlecase }}
        </div>
      </div>
    </section>

  </ng-container>

</ng-container>

<ng-template #skeletonView>
  <lib-block-title
    *ngIf="uiFramework === 'material'"
    id="title"
    [title]="title">
    <ion-skeleton-text
      animated="true"
      class="h-6 w-32">
    </ion-skeleton-text>
  </lib-block-title>

  <div
    id="product-image"
    class="fx-col fx-gap-2 py-2 fx-center radius-4 block-bg-contrast">
    <ion-skeleton-text
      animated="true"
      class="h-20 w-20">
    </ion-skeleton-text>
    <ion-skeleton-text
      animated="true"
      class="h-5 w-32">
    </ion-skeleton-text>
    <ion-skeleton-text
      animated="true"
      class="h-5 w-24">
    </ion-skeleton-text>
  </div>

  <section id="product-details">
    <div
      *ngFor="let i of [].constructor(skeletonItemsCount)"
      class="fx-row radius-4 block-bg-contrast fx-align-center fx-gap-3 fx-justify-between p-3">
      <ion-skeleton-text
        animated="true"
        class="h-6 w-6">
      </ion-skeleton-text>
      <ion-skeleton-text
        animated="true"
        class="h-5 w-24">
      </ion-skeleton-text>
      <ion-skeleton-text
        animated="true"
        class="h-5 w-24 ml-auto">
      </ion-skeleton-text>
    </div>
  </section>
</ng-template>